import { PostFile } from './post-file.model';

export class Post {

  public isExpanded;

  constructor(public id: number,
              public title: string,
              public content: string,
              public file: PostFile,
              public dateCreated: Date,
              public tags: string[]) {
    this.isExpanded = false;
  }
}
